import React from 'react';

type Props = {
  children: React.ReactChild[];
};

function StepGroup({ children }: Props) {
  const activeIndex = children.findIndex((child) => child.props.active === true);

  return (
    <ol className="divide-y divide-gray-300 md:flex md:divide-y-0 md:flex-wrap md:justify-center">
      {children.map((child, index) => {
        const isActive = index <= activeIndex;
        const color = isActive ? 'text-blue-700' : 'text-gray-400';
        return (
          <li className={`relative md:flex ${color} md:max-h-10`} key={`step-${index}`}>
            <span className="group flex items-center">
              <span className={`${index === 0 ? 'px-4 md:pl-0' : 'px-4'} flex items-center py-3 text-sm font-medium`}>
                {isActive ? (
                  <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-blue-600">
                    <svg
                      className="h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                ) : (
                  <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 text-white">
                    <svg
                      className="h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                )}
                <div className="contents">{child}</div>
              </span>
            </span>
            {index !== children.length - 1 && (
              <div className="hidden h-full w-5 md:block" aria-hidden="true">
                <svg className="h-full w-full text-gray-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
                  <path
                    d="M0 -2L20 40L0 82"
                    vectorEffect="non-scaling-stroke"
                    stroke="currentcolor"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}
          </li>
        );
      })}
    </ol>
  );
}

export default StepGroup;
